/* unplugin-vue-components disabled */import script from "./ProductSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSelector.vue?vue&type=script&setup=true&lang=js"

import "./ProductSelector.vue?vue&type=style&index=0&id=ab336076&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab336076"]])

export default __exports__